
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/detailed-overview",
      function () {
        return require("private-next-pages/detailed-overview.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/detailed-overview"])
      });
    }
  